import {defineStore} from 'pinia';
import {AUTH_CODES} from '@/shared/constants/authCodes.ts';
import {getAuthentication} from '@/services/administration/authorization.ts';
import type {UserAuth} from "@/services/interfaces/administration/UserAuth.ts";

interface AuthState {
    accessToken: string | null;
    user: {
        user_data: UserAuth | null;
        user_rol: string | null;
    };
}

const getFromLocalStorage = (key: string) => {
    return localStorage.getItem(key);
}

const getParsedFromLocalStorage = (key: string) => {
    const item = localStorage.getItem(key);
    try {
        return item ? JSON.parse(item) : null;
    } catch {
        localStorage.removeItem(key);
        return null;
    }
}


export const useAuthStore = defineStore('auth', {
    state: (): AuthState => ({
        accessToken: getFromLocalStorage(AUTH_CODES.ACCESS_TOKEN),
        user: {
            user_data: getParsedFromLocalStorage(AUTH_CODES.USER_DATA),
            user_rol: getFromLocalStorage(AUTH_CODES.ROL)
        },
    }),
    actions: {
        async loadUserProfile(username: string, password: string) {
            const userAuth = await getAuthentication(username, password);
            this.setUserData(userAuth)
            this.setToken(userAuth.token)
            this.setRol(userAuth.NOMBRE_R)
        },
        logout() {
            this.accessToken = null;
            this.user.user_rol = null;
            this.user.user_data = null;
            localStorage.clear();
        },
        setUserData(data: UserAuth | null | undefined) {
            if (data) {
                localStorage.setItem(AUTH_CODES.USER_DATA, JSON.stringify(data));
                this.user.user_data = data;
            } else {
                localStorage.removeItem(AUTH_CODES.USER_DATA);
                this.user.user_data = null;
            }
        },
        setToken(token: string){
            localStorage.setItem(AUTH_CODES.ACCESS_TOKEN, token)
            this.accessToken = token
        },
        setRol(rol: string){
            localStorage.setItem(AUTH_CODES.ROL, rol)
            this.user.user_rol = rol
        },
        hasModule(module: string): boolean {
          return !!this.user.user_data?.permisos.find(m => m.DESCRIPCION_M.toUpperCase() === module.toUpperCase())
        }
    },
});